import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";

const LanguageValueField = ({ lang, obj, onChange, label, multiline, minRows, required, helperText, error}) => {
  const [textValue, setTextValue] = useState("");
  // console.log(label, obj);

  useEffect(() => {
    const existingValue = obj.getValues().find(item => item.language === lang);
    setTextValue(existingValue ? existingValue.value : ""); // Set initial value
  }, [obj, lang]);


  const updateObj = (e) => {
    const newValue = e.target.value;
    setTextValue(newValue);

    if (obj) {
      if (newValue === "") {
        // Remove the language entry if the value is empty
        const indexToRemove = obj.getValues().findIndex(item => item.language === lang);
        if (indexToRemove !== -1) {
          obj.remove(indexToRemove);
        }
      } else {
        obj.update(lang, newValue); // Update or add the new language-value pair
      }

      if (onChange) {
        // Send the updated object to the parent
        onChange(obj); // Send the updated LanguageValueList object to the parent
      }
    }
  };

  return (
    <TextField
      fullWidth
      multiline={multiline}
      minRows={minRows}
      label={label}
      required={required}
      helperText={helperText}
      variant={"filled"}
      // variant={multiline ? "outlined" : "filled"}
      value={textValue}
      onChange={updateObj}
      // error={error ? !!error : false}
    />
  );
};

export default LanguageValueField;
